// extracted by mini-css-extract-plugin
export default {"frame":"DiscountPop_frame__j-OKi","itemobj":"DiscountPop_itemobj__FAEkv","discount":"DiscountPop_discount__Nu42r","animate-rotate":"DiscountPop_animate-rotate__mAiVS"};